module.exports = __webpack_public_path__ + "static/media/IconSub.781a30fc.svg";